





























































import { Component, Vue } from "vue-property-decorator";
import { Carousel3d, Slide } from "vue-carousel-3d";
import { baseMbList, BaseMbListJson } from "./config";
import "./flex";
import getOpenInstall from "./openInstall.js";
import topCom from "./components/topCom.vue";
import topComs from "./components/topComs.vue";
import aboutUs from "./components/aboutUs.vue";
import productInfo from "./components/productInfo.vue";
import permit from "./components/permit.vue";
import softwareLis from "./components/softwareLis.vue";
import privacy from "./components/privacy.vue";

@Component({
  components: {
    Carousel3d,
    Slide,
    topCom,
    topComs,
    aboutUs,
    productInfo,
    permit,
    softwareLis,
    privacy
  }
})
export default class Home extends Vue {
  public drawerShowOne = false;
  public limits = 1;
  public drawerShowTitle = "";
  public list: any = [
    "/static/img/360img/mb_swiper_one.png",
    "/static/img/360img/mb_swiper_two.png",
    "/static/img/360img/mb_swiper_three.png",
    "/static/img/360img/mb_swiper_four.png",
    "/static/img/360img/mb_swiper_five.png"
  ];
  public lists: any = [
    "/static/img/baseImg/base_mb_one.jpg",
    "/static/img/baseImg/base_mb_two.jpg",
    "/static/img/baseImg/base_mb_three.jpg",
    "/static/img/baseImg/base_mb_four.jpg",
    "/static/img/baseImg/base_mb_five.jpg"
  ];
  public limit = 0;
  public mobile = "";
  public baseInfo: any = {};
  public created() {
    this.mobile =
      navigator.appVersion.indexOf("iPhone") !== -1 ? "iPhone" : "android";
    const arr = baseMbList.filter((item: BaseMbListJson) => {
      return this.$route.name == item.name || this.$route.path == item.path;
    });
    this.baseInfo = arr[0];
    if (this.baseInfo.isSigmob) {
      (window as any).sigmob.track("pageview");
    }
  }
  public onSlideChange(val) {
    this.limit = val;
  }
  public stop(state) {
    const isShow = this.baseInfo.linkList.some(item => {
      return state == item;
    });
    if (!isShow) return false;
    document.body.style.overflow = "hidden";
    this.limits = state;
    switch (this.limits) {
      case 0:
        this.drawerShowTitle = "关于我们";
        break;
      case 1:
        this.drawerShowTitle = "产品介绍";
        break;
      case 2:
        this.drawerShowTitle = "服务条款";
        break;
      case 3:
        this.drawerShowTitle = "软件许可协议";
        break;
      case 4:
        this.drawerShowTitle = this.baseInfo.linkText || "权限&隐私政策";
        break;
      default:
        break;
    }
    this.drawerShowOne = true;
  }
  public download() {
    if (this.baseInfo.isSigmob) {
      (window as any).sigmob.track("other");
    }
    if (
      this.baseInfo.azLink &&
      (this.baseInfo.iosInstall || this.baseInfo.iosLink)
    ) {
      if (this.mobile == "iPhone") {
        if (this.baseInfo.iosInstall) {
          getOpenInstall(
            this.baseInfo.iosInstall[0],
            this.baseInfo.iosInstall[1]
          );
        }
        if (this.baseInfo.iosLink) {
          window.open(this.baseInfo.iosLink, "_self");
        }
      }
      if (this.mobile == "android") {
        const sUserAgent = navigator.userAgent.toLowerCase();
        if (sUserAgent.indexOf("baidu") > 0) {
          alert(
            "如提示'第三方页面应用未经百度审核'，请使用系统自带浏览器下载APP"
          );
        }
        window.open(this.baseInfo.azLink, "_self");
      }
    } else {
      if (this.baseInfo.iosInstall || this.baseInfo.iosLink) {
        if (this.baseInfo.iosInstall) {
          getOpenInstall(
            this.baseInfo.iosInstall[0],
            this.baseInfo.iosInstall[1]
          );
        }
        if (this.baseInfo.iosLink) {
          window.open(this.baseInfo.iosLink, "_self");
        }
      }
      if (this.baseInfo.azLink) {
        const sUserAgent = navigator.userAgent.toLowerCase();
        if (sUserAgent.indexOf("baidu") > 0) {
          alert(
            "如提示'第三方页面应用未经百度审核'，请使用系统自带浏览器下载APP"
          );
        }
        window.open(this.baseInfo.azLink, "_self");
      }
    }
    if (this.baseInfo.isSguic) {
      (window as any).sguic(
        this.baseInfo.isSguic[0],
        this.baseInfo.isSguic[1],
        this.baseInfo.isSguic[2]
      );
    }
  }
}
